import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import TableContent from "../../table/table";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateAgencyTypeAction,
  DeleteAgencyTypeAction,
  GetAllAgencyTypeAction,
  UpdateAgencyTypeAction,
} from "../../../../redux/actions/AgencyTypeAction";
import { ToastContainer } from "react-toastify";
const Typemowkel = () => {
  const [Namee, setNamee] = useState("");
  const [Note, setNote] = useState("");
  const [IDTawkelType, setIDTawkelType] = useState("");
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setIDTawkelType(itemid);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAgencyTypeAction(IDTawkelType));
    setLoading(false);
    setIDTawkelType("");
    setshowDelete(false);
    setIsPress(false);
  };
  const ALL = useSelector((state) => state.AgencyTypeR.getAgencyType);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllAgencyTypeAction());
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Namee === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      CreateAgencyTypeAction({
        Name: Namee,
        Note: Note,
      })
    );
    setNamee("");
    setNote("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (Namee === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateAgencyTypeAction({ Id: IDTawkelType, Name: Namee, Note: Note })
    );
    setNamee("");
    setNote("");
    setIsPress(false);
    setIsEdit(false);
    setLoading(false);
  };
  const Update = (item) => {
    setNamee(item.Name);
    setNote(item.Note);
    setIDTawkelType(item.Id);
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = (item) => {
    setNamee(item.Name);
    setNote(item.Note);
    // setIDTawkelType(item.Id);
    setIsEdit(false);
    setEye(true);
  };
  const res = useSelector((state) => state.AgencyTypeR.InsertAgencyType);
  const UP = useSelector((state) => state.AgencyTypeR.UpdateAgencyType);
  const DEL = useSelector((state) => state.AgencyTypeR.DeleteAgencyType);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage ===
              "Great, agency type created Successfully"
          ) {
            dispatch(GetAllAgencyTypeAction());
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage ===
              "Great, agency Type updated Successfully"
          ) {
            dispatch(GetAllAgencyTypeAction());
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, agency type deleted Successfully"
          ) {
            dispatch(GetAllAgencyTypeAction());
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Can't delete because you are using it"
          ) {
            notify("لا يمكن حذف نوع التوكيل لانه مستخدم", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    نوع التوكيل
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                value={Namee}
                onChange={(e) => setNamee(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="ملاحظات"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                variant="outlined"
                //   className="ww"
              />
            </div>

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                نوع التوكيل <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(ALL) && ALL.length > 0
              ? ALL.map((item) => (
                  <tr key={item.Id} onDoubleClick={() => Update(item)}>
                    <td>{item.Name}</td>
                    <td>{item.Note}</td>
                    <td className="icon-w" onClick={() => Update(item)}>
                      <i
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleEye(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
      </div>
      <ToastContainer autoClose={1200} />
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default Typemowkel;
